import _getPrototypeOf from './getPrototypeOf.js';

function _superPropBase(object, property) {
  while (!Object.prototype.hasOwnProperty.call(object, property)) {
    object = _getPrototypeOf(object);
    if (object === null) break;
  }
  return object;
}

export { _superPropBase as default };
